export function setJoined() {
    localStorage.setItem("joined", 1);
}

export function hasJoined() {
    return localStorage.getItem("joined");
}